/**
 * Shared column identity constants (plan 2026-09-28-001 U1, clay 11) —
 * de-duplicates the `PINNED_COLUMN_KEY` constant `FlowTable`, `LedgerTable`,
 * `LedgerToolbar`, and `ColumnsManager` each declared locally. Also holds the
 * role-free column width helpers.
 */

/** The pinned, always-first, non-draggable identity column — shared by
 *  FlowTable, LedgerTable, LedgerToolbar, ColumnsManager callers. */
export const PINNED_COLUMN_KEY = 'name';

/** The widths the table draws: the role's `defaults`, then every stored width over them. */
export function withDefaultWidths(
  defaults: Readonly<Record<string, number>>,
  stored: Record<string, number> | undefined,
): Record<string, number> {
  return { ...defaults, ...stored };
}

/**
 * What to store when the table reports `next`: the stored widths as they were,
 * plus every column whose reported width differs from the role's default. A
 * default the user never touched is never written to the working state.
 */
export function storedWidths(
  defaults: Readonly<Record<string, number>>,
  next: Record<string, number>,
  stored: Record<string, number> | undefined,
): Record<string, number> {
  const out: Record<string, number> = {};
  for (const [key, width] of Object.entries(next)) {
    if (stored?.[key] !== undefined || width !== defaults[key]) out[key] = width;
  }
  return out;
}
